import { useQuery } from '@tanstack/react-query';
import * as ebayPricingService from '../services/ebayPricingService';
import { useAuth } from '../contexts/AuthContext';

export function useEbayPricing(params: ebayPricingService.EbaySearchParams, enabled: boolean = true) {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: ['ebayPricing', params.setId, params.cardNumber, params.cardName],
    queryFn: () => ebayPricingService.searchEbayPricing(params),
    enabled: enabled && !!params.cardName,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
}

export function useGradedPricing(params: ebayPricingService.EbaySearchParams, enabled: boolean = true) {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: ['gradedPricing', params.setId, params.cardNumber, params.cardName],
    queryFn: () => ebayPricingService.searchGradedPricing(params),
    enabled: enabled && !!params.cardName,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
}
